import { Typography } from '@components/Typography';
import { ProfileType } from '@constants/integrations';
import { getIntegrationIcon } from '@helpers/integrations';
import { InfoChip } from './styles';

const IntegrationChip = ({ profileName, link }) => {
    const label = ProfileType[profileName];
    if (!label) return null;
    const chip = (
        <InfoChip clickable={!!link}>
            {getIntegrationIcon(profileName)}
            <Typography variant="caption" sx={{ color: 'var(--text-primary)' }}>
                {label}
            </Typography>
        </InfoChip>
    );
    if (!link) return chip;
    return (
        <a href={link} target="_blank" rel="noreferrer noopener" style={{ textDecoration: 'none' }}>
            {chip}
        </a>
    );
};

export default IntegrationChip;
